import FormatCurrency from 'components/Common/FormatCurrency'
import Pill from 'components/Luxkit/Pill'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import { EXPERIENCE_MINIMUM_DISCOUNT_PERCENTAGE_TO_SHOW } from 'constants/experience'
import React from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { rem } from 'polished'
import styled from 'styled-components'

const ValueWrapper = styled(Caption)`
  display: flex;
  gap: ${rem(4)};
  flex-wrap: wrap;
  align-items: center;
`

interface Props {
  experience: App.ExperienceBookingView
}

export const ExperienceOfferPriceDetails = ({ experience }: Props) => {
  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <Group direction="vertical" horizontalAlign="space-between" verticalAlign="end">
        <Caption variant="large" colour="neutral-three">From</Caption>
        <Heading variant="heading4">
          <FormatCurrency value={experience.price} format="roundedDollar" />
          {experience.ticketUnitLabel && <Caption variant="medium" as="span" colour="neutral-two">/{experience.ticketUnitLabel}</Caption>}
        </Heading>
        {experience.discount >= EXPERIENCE_MINIMUM_DISCOUNT_PERCENTAGE_TO_SHOW && (
          <ValueWrapper variant="large" weight="bold" colour="neutral-one">
            Valued up to <FormatCurrency value={Math.ceil(experience.grossPrice)} />
            <Pill kind="primary" variant="success">-{experience.discount}%</Pill>
          </ValueWrapper>
        )}
      </Group>
      <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          View
        </TextButton>
      </CSSBreakpoint>
    </Group>
  )
}
